import React, { useState } from 'react';
import CompletedItemIcon from '../../../../assets/images/Completed Item Icon.svg';
import ArrowUpIcon from '../../../../assets/images/Arrow Up Icon.svg';
import ArrowDownIcon from '../../../../assets/images/Arrow Down Icon.svg';
import IncompleteQuestionItemIcon from '../../../../assets/images/Incomplete Question Item Icon.svg';

interface Question {
    answerDetails: { isCorrect: boolean }[];
}

interface CountertopProfileQuizBlockProps {
    question: Question;
    index: number;
    hasAttempts: boolean;
    isExpanded: boolean;
    isTakeQuizDisabled?: boolean;
    setIsQuestionPopupVisible: (visible: boolean) => void;
    setCurrentQuestionNumber: (index: number) => void;
    setExpandedIndex: (index: number | null) => void;
    resetQuestionPopup: () => void;
}

const CountertopProfileQuizBlock: React.FC<CountertopProfileQuizBlockProps> = ({
    question,
    index,
    hasAttempts,
    isExpanded,
    isTakeQuizDisabled,
    setIsQuestionPopupVisible,
    setCurrentQuestionNumber,
    setExpandedIndex,
    resetQuestionPopup
}) => {
    return (
        <div className="countertop-university-quiz-block">
            <span>
                <img
                    className="countertop-university-quiz-img"
                    style={!question.answerDetails.some(x => x.isCorrect) ? { cursor: 'pointer' } : {}}
                    src={question.answerDetails.some(x => x.isCorrect) ? CompletedItemIcon : IncompleteQuestionItemIcon}
                    alt="Item Icon"
                    onClick={() => {
                        if (isTakeQuizDisabled) return;
                        resetQuestionPopup();

                        if (!question.answerDetails.some(x => x.isCorrect)) {
                            setIsQuestionPopupVisible(true);
                            setCurrentQuestionNumber(index);
                        }
                    }}
                />
            </span>
            <span className="countertop-university-quiz-block-question-count">
                &nbsp;&nbsp;Question {index + 1}&nbsp;&nbsp;
            </span>
            <span>
                <img
                    src={isExpanded ? ArrowUpIcon : ArrowDownIcon}
                    className="attempt-arrow"
                    onClick={() => {
                        if (hasAttempts) {
                            setExpandedIndex(isExpanded ? null : index);
                        }
                    }}
                />
            </span>
        </div>
    );
};

export default CountertopProfileQuizBlock;